/**
 * ChooseLandmarkCard applier.
 *
 * - Appends `cardId` to the active player's `landmarkPicks`.
 * - Places a landmark token on the just-placed tile:
 *     board.cells[justPlacedCoord].landmark = { habitat: card.habitat }
 * - Advances phase: unlockLandmark → endTurn.
 *
 * Spec §9.2.
 */

import { LANDMARK_CARDS_BY_ID } from "../data/landmark-cards";
import type { ChooseLandmarkCardAction } from "../types/actions";
import { coordKey } from "../types/coords";
import type { GameState } from "../types/game-state";
import { bumpVersion } from "./common-applier";

export const applyChooseLandmarkCard = (
  state: GameState,
  action: ChooseLandmarkCardAction,
): GameState => {
  const activeSeat = state.turn.activeSeat;
  const activePlayer = state.players[activeSeat]!;
  const card = LANDMARK_CARDS_BY_ID[action.cardId]!;
  const placedCoord = state.turn.actionBudget.justPlacedTileCoord!;
  const key = coordKey(placedCoord);
  const existingCell = activePlayer.board.cells[key]!;

  return {
    ...state,
    ...bumpVersion(state),
    turn: {
      ...state.turn,
      phase: "endTurn",
    },
    players: state.players.map((p) =>
      p.seat === activeSeat
        ? {
            ...p,
            landmarkPicks: [...p.landmarkPicks, action.cardId],
            board: {
              cells: {
                ...p.board.cells,
                [key]: {
                  ...existingCell,
                  landmark: { habitat: card.habitat },
                },
              },
            },
          }
        : p,
    ),
  };
};
